const STORAGE_KEY = "neo_seo_anonymous_visitor_id";

function createAnonymousVisitorId() {
  if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") {
    return crypto.randomUUID();
  }
  return `anon-${Math.random().toString(36).slice(2)}-${Date.now().toString(36)}`;
}

export function getAnonymousVisitorId() {
  if (typeof window === "undefined") return "";

  const existing = window.localStorage.getItem(STORAGE_KEY);
  if (existing) return existing;

  const created = createAnonymousVisitorId();
  window.localStorage.setItem(STORAGE_KEY, created);
  return created;
}
